module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6536d2d814262dd5860b9ff6a89af64e.png";